import { useState } from 'react'
import { Alert, Snackbar } from '@mui/material'
import { useAppData } from '../contexts/AppDataContext'
import { useEventStream } from '../hooks/useEventStream'

/**
 * Listens to the event's SSE stream. On a "notification" it shows a banner; on
 * content changes it broadcasts a window event so pages can revalidate.
 */
export default function RealtimeBanner() {
  const { event } = useAppData()
  const [msg, setMsg] = useState<{ title: string; body?: string } | null>(null)

  useEventStream(event?.id, (data) => {
    if (data.kind === 'notification') {
      setMsg({ title: String(data.title ?? ''), body: data.body ? String(data.body) : undefined })
    } else {
      // agenda / content / forms / event changed — let pages refetch.
      window.dispatchEvent(new CustomEvent('vc:changed', { detail: data }))
    }
  })

  return (
    <Snackbar
      open={Boolean(msg)}
      autoHideDuration={8000}
      onClose={() => setMsg(null)}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert severity="info" variant="filled" onClose={() => setMsg(null)} sx={{ borderRadius: 2 }}>
        <strong>{msg?.title}</strong>
        {msg?.body ? ` — ${msg.body}` : ''}
      </Alert>
    </Snackbar>
  )
}
